import * as React from 'react';

export default function Refs(...refs: string[]) {
  let _refs: { [key: string]: React.RefObject<{}> } = {};
  for (let i = 0; i < refs.length; i++) {
    let key = refs[i];
    _refs[key] = React.createRef();
  }
  return function <TComponent extends React.ComponentClass<TProps>, TProps = any>(
    componentClass: TComponent
  ): ComponentWithRefs<TComponent, TProps> {
    componentClass.prototype._refs = _refs;
    return componentClass as ComponentWithRefs<TComponent, TProps>;
  };
}

export interface WithRefs {
  _refs: { [key: string]: React.RefObject<{}> };
}

export type ComponentWithRefs<T extends React.ComponentClass<P>, P = any> = T & WithRefs;
